var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":""}},[_c('v-img',{attrs:{"src":require("@/assets/logo.png"),"max-width":"40","contain":""}}),_c('v-toolbar-title',[_vm._v("Hermes")]),_c('v-spacer')],1),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }